import { CheckoutState } from '../state';
import { getCaptchaV3TimeoutReached, getCaptchaV3Token } from './app';
import { getHasPromoCode } from './event';
import { isRecaptchaV3Enabled } from './splitio';
import { getHasTicketsWithPromoCodeApplied, hasFreeTickets } from './tickets';

export const getIsTicketSelectionButtonDisabledByCaptcha = (
    state: CheckoutState,
) =>
    isRecaptchaV3Enabled(state) &&
    (hasFreeTickets(state) ||
        getHasPromoCode(state) ||
        getHasTicketsWithPromoCodeApplied(state)) &&
    !getCaptchaV3Token(state) &&
    !getCaptchaV3TimeoutReached(state);
